import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { CarauselComp } from '../../../atoms/Carausel/Presentation/CarauselComp';
import { ButtonComp } from '../../../atoms/Buttons';
import ImageComponent from '../../../atoms/Image';
import MARKETING_HERO_CONSTANTS from '../Constants/MarketingConstants';
import ChangingProgressProvider from '../ChangingProgressProvider';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import { getTernaryValue, getValueOrEmptyString, isElementInViewport } from 'common/utilities/utils';
import { setMarketingAnalyticsOnLoad } from 'organisms/MarketingHero/MarketingUtilities/marketingUtils';
import PropTypes from 'prop-types';
import { useCarousalDataIN } from 'customHooks';
export const clickImageHandler = (
  displayButton,
  e,
  clickImageAnalytics,
  analyticsData,
  ind,
  item,
  currencyShortName,
  clickHandler,
) => {
  if (!displayButton) {
    e.preventDefault();
  }
  clickImageAnalytics(analyticsData, ind, item, currencyShortName, clickHandler);
};
export const RegionalMarketingItems = props => {
  const { SLIDE_CHANGE_INTERVAL, LIGHT, BLACK_COLOR, WHITE_COLOR } = MARKETING_HERO_CONSTANTS;
  const {
    contentData = [],
    animationSpeed = SLIDE_CHANGE_INTERVAL,
    clickHandler,
    clickImageAnalytics,
    isMobile = false,
  } = props;
  const [nextIndex, setNextIndex] = useState(0);
  const tenantData = useSelector(data => data?.tenantReducer);
  const { currencyShortName } = tenantData;
  const [viewPromotionEventCall, setviewPromotionEventCall] = useState([]);

  const fetchColor = () => {
    return contentData?.[0]?.textColor.toUpperCase() === LIGHT ? 'white-color' : 'black-color';
  };
  const getColorBasedOnText = () => {
    if (contentData?.[nextSlideIndex].textColor.toUpperCase() === LIGHT) {
      colorChange = 'white-color';
    } else {
      colorChange = 'black-color';
    }
    return colorChange;
  };

  let nextSlideIndex = 0;
  let colorChange = fetchColor();
  const viewPromotionsVariables = {
    nextIndex,
    viewPromotionEventCall,
    setviewPromotionEventCall,
    isElementInViewport,
  };
  useCarousalDataIN(contentData, setMarketingAnalyticsOnLoad, currencyShortName, viewPromotionsVariables);
  const settings = {
    dots: true,
    infinite: true,
    autoplaySpeed: animationSpeed * 1000, // converting seconds to milliseconds
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    adaptiveHeight: true,
    autoplay: true,
    accessibility: true,
    beforeChange: (currentIndex, nextIndex) => {
      nextSlideIndex = nextIndex !== contentData?.length ? nextIndex : 0;
      colorChange = getColorBasedOnText();
      setNextIndex(getTernaryValue(nextIndex !== contentData.length, nextIndex, 0));
    },
    customPaging: currentInd => {
      let incrementedNo = currentInd + 1;
      let formattedNumber = incrementedNo.toLocaleString('en-US', {
        minimumIntegerDigits: 2,
      });
      let progressbar_textcolor = colorChange === 'white-color' ? WHITE_COLOR : BLACK_COLOR;
      return currentInd === nextSlideIndex ? (
        <ChangingProgressProvider values={[0, 33, 66, 100]}>
          {percentage => (
            <CircularProgressbar
              value={percentage}
              text={formattedNumber}
              styles={buildStyles({
                pathTransitionDuration: 2.5,
                textColor: progressbar_textcolor,
                pathColor: progressbar_textcolor,
              })}
              tabIndex='0'
            />
          )}
        </ChangingProgressProvider>
      ) : (
        <div
          className={`${colorChange} carausel-paging`}
          data-testid={`carausel-paging-handler-${currentInd}`}
          onClick={() => (nextSlideIndex = currentInd)}
          aria-label={`Slide ${formattedNumber}`}
          tabIndex='0'
          role='button'
        >
          <span className='carausel-pagingNo'>{formattedNumber}</span>
        </div>
      );
    },
  };

  const [isPotrait, setIspotrait] = useState(window.innerHeight > window.innerWidth);

  useEffect(() => {
    if ('onorientationchange' in window) {
      window.addEventListener('orientationchange', windowResized);
      return () => {
        window.removeEventListener('orientationchange', windowResized);
      };
    }
  }, []);

  const windowResized = () => {
    setIspotrait(window.innerHeight < window.innerWidth);
  };

  /* draw carausel component in below header */
  const drawCarausel = () => {
    return contentData.map((item, ind) => {
      const { smallText, largeText, buttonText, showButton, desktopSrc, mobileSrc, alt, textColor, analyticsData } =
        item || {};
      const displayButton = showButton.toUpperCase() === MARKETING_HERO_CONSTANTS.YES_CONSTANT;
      const imageSrc = isPotrait || isMobile ? mobileSrc : desktopSrc;
      const ariaText = `${buttonText} for ${largeText}`;

      return (
        <React.Fragment key={ind}>
          {/*  <div className='marketing-hero' key={ind} onClick={displayButton ? (e) => e.preventDefault() : () => clickImageAnalytics(analyticsData, ind)} style={{
                        backgroundImage: `url(${src})`
                    }
                    }>
                        <div className='carausel-text-span'>
                            <div className='carausel-inner-positions'>
                                {smallText && <div className={`${textColor.toUpperCase() === LIGHT ? 'color-white' : 'color-black'} smallTxtHero`}>{smallText}</div>}
                                {largeText && <div className={`${textColor.toUpperCase() === LIGHT ? 'color-white' : 'color-black'} largeTextHero`}>{largeText}</div>}
                                {displayButton && buttonText &&
                                    <ButtonComp
                                        className={'button redButton carauselOrderNow '}
                                        aria-label={buttonText || ''}
                                        onClickHandler={() => clickHandler(analyticsData, ind)}
                                    >
                                        <span>{buttonText}</span>
                                    </ButtonComp>}
                            </div>

                        </div>
                    </div > */}
          <div
            className={getTernaryValue(displayButton, 'removePointer', 'marketing-hero-img-div')}
            tabIndex='0'
            role='clickable image'
            key={ind}
            data-testid={`click-image-analytics-${ind}`}
            onClick={e =>
              clickImageHandler(
                displayButton,
                e,
                clickImageAnalytics,
                analyticsData,
                ind,
                item,
                currencyShortName,
                clickHandler,
              )
            }
            /* style={{
            backgroundImage: `url(${imageSrc})`
          }} */
          >
            <ImageComponent
              data-testid='image-component'
              srcFile={imageSrc}
              isContentfulImage={true}
              alt={alt}
              className='carausel-image'
            />
            {smallText && (
              <div className={`${textColor.toUpperCase() === LIGHT ? 'color-white' : 'color-black'} smallTxtHero`}>
                {smallText}
              </div>
            )}
            {largeText && (
              <div className={`${textColor.toUpperCase() === LIGHT ? 'color-white' : 'color-black'} largeTextHero`}>
                {largeText}
              </div>
            )}
            {displayButton && buttonText && (
              <ButtonComp
                className={'button redButton carauselOrderNow '}
                aria-label={getValueOrEmptyString(ariaText)}
                data-testid={`click-handler-${ind}`}
                onClickHandler={() => clickHandler(analyticsData, ind, null, item)}
              >
                <span>{buttonText}</span>
              </ButtonComp>
            )}
          </div>
        </React.Fragment>
      );
    });
  };
  return <CarauselComp settings={settings}>{drawCarausel()}</CarauselComp>;
};

RegionalMarketingItems.propTypes = {
  contentData: PropTypes.instanceOf(Object).isRequired,
};

RegionalMarketingItems.defaultProps = {};

export default RegionalMarketingItems;
